<template>
  <section >
    <div class="module-small bg-dark ctaImg">
          <div class="container">
            <div class="row footer-row">
              <div class="col-sm-4">
                <div class="widget">
                  <h5 class="widget-title font-alt">Developed by</h5>
                  <img v-lazy="imgUrl1" alt="Half Human Games">
                </div>
              </div>
              <div class="col-sm-4 second">
                <div class="widget">
                  <h5 class="widget-title font-alt">Social Media</h5>
                  <div class="footer-social-links">
                    <a href="https://discordapp.com/invite/halfhumangames" target="_blank" rel="noopener noreferrer" style="padding-left: 0;"><i class="fab fa-discord fa-2x footer-icon"></i></a>
                    <a href="https://twitter.com/HalfHumanGames/" target="_blank" rel="noopener noreferrer"><i class="fab fa-twitter fa-2x footer-icon"></i></a>
                    <a href="https://www.facebook.com/HalfHumanGames/" target="_blank" rel="noopener noreferrer"><i class="fab fa-facebook fa-2x footer-icon"></i></a>
                     <a href="https://www.instagram.com/halfhumangames/" target="_blank" rel="noopener noreferrer"><i class="fab fa-instagram fa-2x footer-icon"></i></a>
                      <a href="https://www.reddit.com/r/halfhumangames/" target="_blank" rel="noopener noreferrer"><i class="fab fa-reddit fa-2x footer-icon"></i></a>
                    <a href="https://www.youtube.com/channel/UCT6Iqrqj8ZmolRj1yDBN3EQ" target="_blank" rel="noopener noreferrer"><i class="fab fa-youtube fa-2x footer-icon"></i></a>
                </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="widget">
                  <h5 class="widget-title font-alt" id="contact">Contact</h5>
                  <ul style="list-style-type: none;" class="contact">
                    <li><i style="padding-right: 10px; color: #cd2423;" class="fa fa-building" aria-hidden="true"></i><a href="https://halfhumangames.com" target="_blank" rel="noopener noreferrer">Half Human Games</a></li>
                    <li><i style="padding-right: 10px; color: #cd2423;" class="fa fa-envelope " aria-hidden="true"></i><a href="mailto:contact@halfhumangames.com">contact@halfhumangames.com</a></li>
                    <li><i style="padding-right: 10px; color: #cd2423;" class="fa fa-globe " aria-hidden="true"></i><a href="https://halfhumangames.com">halfhumangames.com</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="footer bg-dark">
          <div class="container">
            <div class="row" style="text-align: center;">
              <div class="col-sm-12">
                <p class="copyright font-alt">Copyright &copy; 2020 Half Human Games, LLC.</p>
              </div>
              <div class="col-sm-6">
            
              </div>
            </div>
          </div>
        </footer>
      </section>
</template>


<script>
export default {
  data: function() {
    return {
      imgUrl1: '/static/assets/images/halfhuman-logo.png',
    }
    }
  }
</script>


<style scoped>
.module-small {
    padding: 64px 0 !important;
    
}
h5#contact {
    padding-left: 70px;
}
.row.footer-row .col-sm-4 {
    text-align: left;
}
@media only screen and (min-width: 768px) and (max-width: 1070px) {
  .widget img {
    max-width: 190px !important;
  }
  .bg-dark a {
    padding: 5px !important;
  }
  ul.contact[data-v-375ccf21] {
      padding-left: 0 !important;
    }
}

.footer-icon {
  text-shadow: 2px 2px #080808;
}
.wrapper {
  position: relative;
  left: 8%;
}

.wrapper ul {
  list-style: none;
  margin-left: 6%;
}

.copyright {
  font-family: inherit;
    text-transform: inherit;
    letter-spacing: inherit;
  color: #f1f1f1;
      text-align: center;
}

.wrapper ul li {
  width: 53px;
  height: 75px;
  line-height: 75px;
  margin: 0 0px;
  text-align: center;
  cursor: pointer;
  float: left;
  transition: all 0.5s ease;
}
.widget img {
    max-width: 230px;
    filter: drop-shadow(0 0 .1rem #FDD728);
}
.social-list {
  margin-left: 19%;
  margin-top: 7%;
}
.social-list li {
  display: inline;
  text-align: center;
  padding: 3%;
}

.ctaImg {
  background: url(/static/assets/images/Dwerve-Brick-Texture.png);
}

.cta-title {
  font-family: Grandmaster;
  font-size: 26px;
  position: relative;
  text-align: center;
}
@media only screen and (min-device-width: 300px) and (max-device-width: 600px) {
  .cta-title {
    font-size: 16px;
  }
  h5#contact{
    padding-left: 0;
  }
  ul.contact{
    padding-left: 0px;
  }
}

.footer-logo {
  margin-left: 19%;
  margin-top: 3%;
}
@media (min-width: 1200px) {
  .container {
    width: 90%;
  }
}
.contact {
  list-style-type: none;
  margin-left: 0;
  font-size: 1.2em;
  white-space: nowrap;
  color: #ece8ea;
  font-family: grandmaster;
}
.bg-dark a {
  color: #009595;
  padding: 13px;
  text-decoration: none;
}
.bg-dark a:hover {
    color: #fff;
}
ul.contact {
  font-size: 13px;
    padding-left: 70px;
    text-align: left;
  text-shadow: 2px 2px #080808;
}

@media only screen and (max-width: 800px) {
  .footer-row {
    margin-left: 10px !important;
  }
  .col-sm-4.second {
    margin-bottom: 51px;
    margin-top: 35px;
}
}
@media only screen and (max-width: 1190px) {
  .footer-row {
    margin-left: 5%;
  }
  /* .bg-dark {
    padding: 5px;
  } */
  .contact[data-v-1ae7f56b] {
    white-space: inherit;
  }
  ul.contact {
    font-size: 10px;
    padding-left: 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Home/Footer.vue